import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RequestCallbackView from './request-callback.presenter';
import { closeCallbackRequestModal, openCallbackRequestModal } from '../vantage.actions';

export const mapStateToProps = state => ({
  callbackRequestModalIsOpen: state.vantageReducer.callbackRequestModalIsOpen,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    openCallbackRequestModal,
    closeCallbackRequestModal,
  }, dispatch),
});


const RequestCallback = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequestCallbackView);

export default RequestCallback;
